import {
  getAnonymisedLabel,
  isAnonymisedContact,
} from '../anonymisedContact/anonymisedContact.util'
import type {
  FullContactName,
  GetFullContactNameOptions,
} from './getFullContactName.types'

export function getFullContactName(
  contact: FullContactName,
  options: GetFullContactNameOptions & { showDefaultText: false },
): string | undefined

export function getFullContactName(
  contact: FullContactName,
  options?: GetFullContactNameOptions,
): string

export function getFullContactName(
  contact: FullContactName,
  options: GetFullContactNameOptions = {},
) {
  const { intl, showDefaultText = true } = options

  if (!contact) {
    return showDefaultText ? 'Unknown contact' : undefined
  }

  // an anonymised contact holds a marker in place of its name, so the label stands in for the
  // whole identity rather than for the single fields it was written into
  if (isAnonymisedContact(contact)) {
    return getAnonymisedLabel(intl)
  }

  if (!contact.firstName && !contact.lastName) {
    return showDefaultText ? 'No name given' : undefined
  }

  if (!contact.lastName && contact.firstName) {
    return contact.firstName
  }

  if (!contact.firstName && contact.lastName) {
    return contact.lastName
  }

  return `${contact.firstName} ${contact.lastName}`
}
